export default {
  login: "Login",
  loginCm: "Sign In to your account",
  username: "Username",
  password: "Password",
  forget: "Forgot password?",
  enterUsername: "Please fill in the username.",
  enterPassword: "Please fill in the password.",
  invalidAdmin:"Username or password is invalid!"


}
